import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import api from '~/services/api';
import { isArray } from 'lodash';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';

import ConfirmDialog from '../ConfirmDialog';

import { t } from '~/helpers';

import MyForm from './form';

const formRef = createRef();

class Detalhe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      openConfirmarDialog: false,
      openRecusarDialog: false,
      params: {},
    };
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  // Close modal
  async handleCloseModal() {
    await this.setState({ open: false });
  }

  render() {
    const { open, openConfirmarDialog, openRecusarDialog, params } = this.state;

    return (
      <>
        <Dialog
          classes={{ paper: 'print-area' }}
          open={open}
          maxWidth={'md'}
          onClose={() => this.handleCloseModal()}
        >
          <DialogTitle>
            Recebimento Provisório
          </DialogTitle>
          <DialogContent>
            <MyForm
              data={params}
              reference={formRef}
              close={() => {
                this.handleCloseModal();
                this.props.update();
              }}
            />
          </DialogContent>

          <DialogActions>
            <Button
              className="hide-on-print"
              startIcon={<Close />}
              color="secondary"
              variant="outlined"
              onClick={() => this.handleCloseModal()}
            >
              {t('s.geral.botaocancelar')}
            </Button>


          </DialogActions>
        </Dialog>

      </>


    );
  }
}

export default connect(null, null, null, { forwardRef: true })(Detalhe);
